import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import type { TrackingProviderConfig } from '@shared/common/tracking/domain/model/tracking-provider-config.model';
import type { TrackingService } from '@shared/common/tracking/domain/service/tracking.service';
import { InternalUserService } from '@shared/common/tracking/data/service/internal-user.service';
import { PosthogTrackingService } from '@shared/common/tracking/data/service/posthog-tracking.service';
import { TrackingDependencyTypes } from '@shared/common/tracking/tracking.dependency-types';

export const trackingContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  if (!options.isBound(TrackingDependencyTypes.TrackingProviderConfig)) {
    options.bind<TrackingProviderConfig>(TrackingDependencyTypes.TrackingProviderConfig).toConstantValue({
      apiHost: '',
      uiHost: '',
      apiKey: '',
      internalUserName: '',
    });
  }

  options
    .bind<InternalUserService>(TrackingDependencyTypes.InternalUserService)
    .to(InternalUserService)
    .inSingletonScope();
  options.bind<TrackingService>(TrackingDependencyTypes.TrackingService).to(PosthogTrackingService).inSingletonScope();
});
